<template>
  <List />
</template>
<script>
import '@telexpress_auth/vue-arp/dist/components/List.css';
import List from '@telexpress_auth/vue-arp/dist/components/List.umd.min';

export default {
  components: {
    List,
  },
};
</script>
